/**
 * Labstep
 *
 * @module screens/ResourceItem/Show/Center/SecondaryInfo
 * @desc ResourceItem Show Center Secondary Info
 */

import { EntityLink } from 'labstep-web/components/Entity/Link';
import { MetadataManagerContainer as MetadataManager } from 'labstep-web/components/Metadata/Manager';
import { MetadataTableExtraRows } from 'labstep-web/components/Metadata/Table/ExtraRows';
import { getResourceItemDetails } from 'labstep-web/components/ResourceItem/Details';
import { Card } from 'labstep-web/core/Card/Card';
import { List } from 'labstep-web/core/List';
import { ReadOnMountHOC } from 'labstep-web/hoc/ReadOnMount';
import type React from 'react';
import type { IResourceItemShowCenterSecondaryInfoProps } from './types';

export const ResourceItemShowCenterContentSecondaryInfo: React.FC<
  IResourceItemShowCenterSecondaryInfoProps
> = ({ resourceItem }) => (
  <List>
    <Card>
      <ReadOnMountHOC
        type="cursor"
        entityName={resourceItem.entityName}
        params={{
          id: resourceItem.id,
        }}
        loading={false}
        children={({ entities }) => {
          if (!entities || entities.length === 0) {
            return null;
          }
          return (
            <MetadataTableExtraRows
              rows={getResourceItemDetails(resourceItem)}
              entity={entities[0]}
            />
          );
        }}
      />
    </Card>
    <Card
      data-testid="resource-item-show-metadatas-resource"
      size="mini"
      header={
        <>
          Metadata for <EntityLink entity={resourceItem.resource} />
        </>
      }
    >
      <MetadataManager entity={resourceItem.resource} />
    </Card>
    <Card
      data-testid="resource-item-show-metadatas"
      size="mini"
      header="Metadata specific to this item"
    >
      <MetadataManager entity={resourceItem} />
    </Card>
  </List>
);
